module.exports = __webpack_public_path__ + "assets/img/sdwan-module9-4.a4eb4613.jpg";